export const blogFilters = (function ($) {


    const $DOM = {};


    function init() {
        if(!DomCache()) {
            return;
        }
        parseNavs();
        selectricInit();
    }

    function DomCache () {

        $DOM.container = $(".blog-content-select-box");

        if(!$DOM.container.length) {
            return false;
        }

        $DOM.navs = $DOM.container.find("nav");
        if(!$DOM.navs.length) {
            return false;
        }

        return $DOM;
    }


    function parseNavs() { // convert <ul> to <select>
        $DOM.navs.each(function() {
            let $nav = $(this);
            let $div = $(`<div class="form-container blog-form" />`);
            let $select = $(`<select class="select-form" />`);
            $nav.find("a").each(function() {
                let $a = $(this);
                $select.append(`<option value="${$a.attr("href")}">${$a.text()}</option>`);
            })
            $div.append($select);
            $nav.append($div);
        });
    }


    function selectricInit() {
        $DOM.container.find("select").selectric({
            onInit: function() {
                $DOM.container.addClass("is-init");
            },
            onChange: function(el) {
                document.location.href = el.value;
            }
        });
        $DOM.container.find("select").val(document.location.href).selectric('refresh');
    }


    return {
        init: init
    }


})(jQuery);
